import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">韩漫网</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫网致力于为中文读者提供最优质的韩国漫画在线阅读体验，涵盖浪漫、剧情、悬疑等多种类型，支持免费下拉式阅读。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">浪漫爱情</Link>
              <Link to="/category/drama" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">精彩剧情</Link>
              <Link to="/category/mystery" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">悬疑推理</Link>
              <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">奇幻冒险</Link>
              <Link to="/category/urban" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">都市生活</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系方式</h4>
            <p className="text-sm text-background-400 mb-2">
              <i className="ri-mail-line mr-2"></i>contact@hanman.com
            </p>
            <p className="text-sm text-background-400">
              <i className="ri-customer-service-2-line mr-2"></i>客服在线时间：9:00-21:00
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫网 - 好看的韩国漫画在线阅读平台。本站所有内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}